module.exports = __webpack_public_path__ + "img/hcml_gallery9.2a5bae57.jpg";